<template>
  <div class="basic_retrieve_password_index">
    <div class="tooptipPart module_edit_btn">
       <my_edit_btn :module="module"></my_edit_btn>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="retrieve_password step_0">
      <div class="main_wrapper">
        <p class="mb_title">{{$t('widgets_basic_retrieve_password_edit_2807')}}</p>
        <div class="retrieve_password_header">
          <p class="header_title">{{$t('widgets_basic_retrieve_password_index_2808')}}</p>
        </div>
        <div class="form_wrapper">
          <form>
            <div class="form_item form_item_required">
              <label class="my_label">{{$t('view_login_index_32')}}</label>
              <input disabled autocomplete="off" id="username" name="username" class="input_style" type="text" :placeholder="$t('widgets_basic_retrieve_password_index_2809')">
            </div>
            <div class="form_item form_item_required">
              <label class="my_label">{{$t('widgets_basic_login_index_2566')}}</label>
              <div class="yzm_contain">
                <input disabled style="width: 40%;" autocomplete="off" maxlength="4" id="verify" name="verify" class="input_style" type="text" 
                :placeholder="$t('widgets_basic_retrieve_password_index_2810')">
                <img id="validateCode_img" :alt="$t('widgets_basic_login_index_2566')" src="/static/image/verify.png" class="validateCode_img"/>
                <span class="chang_yzm">{{$t('widgets_basic_retrieve_password_index_2811')}}</span>
              </div>
            </div>
            <div class="form_item form_item_btn">
                <button class="btn_confirm primary_btn" @click="onClickConfirmBtn" type="button">{{$t('widgets_basic_retrieve_password_index_2812')}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'


export default {
  name: "basic_retrieve_password_index",
  components: {
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },
  computed: {
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    }
  },
  methods: {
      onClickConfirmBtn() {
      this.$message.info(i18n.t('components_set_link_components_submit_form_index_2470'))
    }
  }

}
</script>

<style scoped lang="scss">
.basic_retrieve_password_index {
  padding: 0 32px;
}
.basic_retrieve_password {
  .mb_title {
    display: none;
  }
  .validateCode_img {
    height: 44px;
    width: 121px;
    box-sizing: border-box;
    max-width: 100%;
    vertical-align: top;
    margin-left: 20px;
  }
  .chang_yzm {
    color: var(--theme_color);
    font-size: 14px;
    display: inline-block;
    margin-left: 20px;
  }
  .retrieve_password, .main_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .retrieve_password_header {
      width: 100%;
      display: inline-block;
      text-align: center;
      .header_title{
        color: #505D69FF;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 500;
      }
  }
  .main_wrapper {
    width: 100%;
  }
  .form_wrapper {
    width: 100%;
    min-width: 500px;
  }
  .form_item {
    display: flex;
    align-items: center;
    margin-top: 25px;
    position: relative;
    .my_label {
      width: 6em;
      font-size: 14px;
      text-align: right;
      color: #333333FF;
    }
    &.form_item_required {
      .my_label:before {
        content: "*";
        color: #C9544CFF;
        margin-right: 4px;
      }
    }
    .label-placeholder {
      width: 5em;
    }
  }
  .yzm_contain {
    display: flex;
    align-items: center;
    width: 100%;
    flex: 1;
  }
    input::-webkit-input-placeholder {
    font-style: inherit;
    text-decoration: inherit;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    font-family: inherit;
    text-align: inherit;
    background-image: inherit;
    -webkit-background-clip: text;
  }

  input:-moz-placeholder {
    font-style: inherit;
    text-decoration: inherit;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    font-family: inherit;
    text-align: inherit;
    background-image: inherit;
    -webkit-background-clip: text;
  }

  input::-moz-placeholder {
    font-style: inherit;
    text-decoration: inherit;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    font-family: inherit;
    text-align: inherit;
    background-image: inherit;
    -webkit-background-clip: text;
  }

  input:-ms-input-placeholder {
    font-style: inherit;
    text-decoration: inherit;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    font-family: inherit;
    text-align: inherit;
    background-image: inherit;
    -webkit-background-clip: text;
  }
  .input_style {
    flex: 1;
    display: inline-block;
    height: 44px;
    line-height: 44px;
    font-size: 13px;
    box-sizing: border-box;
    background: #F7F8FB;
    border-radius: 3px;
    padding-left: 10px;
    border: 1px solid transparent;
    outline: none;
    margin-left: 20px;
    &:hover {
      border-color: var(--theme_color);
    }
    &:focus {
      border-color: var(--theme_color);
    }
  }
  .btn_confirm {
    margin: 100px auto 20px auto;
  }
  .primary_btn {
    border: 0;
    width: 150px;
    height: 44px;
    cursor: pointer;
    line-height: 44px;
    display: inline-block;
    color: #fff;
    background-color: var(--theme_color);
    border-color: var(--theme_color);
    border-radius: 6px;
  }
}
.mb_pattern .basic_retrieve_password_index {
  margin: 50px 0;
  #validateCode_img {
    width: 80px;
    height: 35px;
  }
  .chang_yzm {
    font-size: 13px;
    font-weight: 500;
  }
  input::-webkit-input-placeholder {
    font-size: 13px;
    color: #66666666;
    font-weight: 500;
  }
  input:-moz-placeholder {
    font-size: 13px;
    color: #66666666;
    font-weight: 500;
  }
  input::-moz-placeholder {
    font-size: 13px;
    color: #66666666;
    font-weight: 500;
  }
  input:-ms-input-placeholder {
    font-size: 13px;
    color: #66666666;
    font-weight: 500;
  }
  .mb_title {
    display: block;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #454545FF;
    text-align: left;
    width: 100%;
    line-height: 25px;
  }
  .retrieve_password_header .header_title{
    width: 100%;
    height: 25px;
    font-size: 13px;
    font-weight: 400;
    color: #8A929E;
    line-height: 25px;
    margin-top: 0;
  }
  .main_wrapper {
    width: 100%;
    order: 2;
    display: flex;
    justify-content: flex-end;
  }
  .form_wrapper {
    width: 100%;
    min-width: 100%;
  }
  .btn_confirm {
    margin-top: 20px;
  }
  .retrieve_password_header {
    text-align: left;
  }
  .form_item {
    flex-direction: column;
    align-items: flex-start;
  }
  .input_style {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }
  .my_label {
    width: auto;
    color: #8A929EFF;
    font-weight: 400;
    font-size: 13px;
  }
  .input_style {
    background: transparent;
    border: none;
    border-bottom: 1px solid #b0b0b0;
    &:hover {
      border-bottom: 1px solid var(--theme_color);
    }
    &:focus {
      border-bottom: 1px solid var(--theme_color);
    }
  }
  .primary_btn,.default_btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_retrieve_password/index.vue